@if (field) {
  <div class="modal fade" id="edit-organization-modal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit</h5>
          <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        @if (field === 'name') {
          <div class="modal-body">
            <label>Name <span class="text-danger small">(required)</span></label>
            <input class="form-control" [ngClass]="setClassInvalidTpl(name)" #name="ngModel" type="text"
              [(ngModel)]="organization.name" placeholder="Organization name" required>
          </div>
        }
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal" [disabled]="!organization.name" (click)="updateOrganization(field)">
            <i class="fa fa-floppy-o"></i> Save
          </button>
        </div>
      </div>
    </div>
  </div>
}